export enum LaunchDarklyIdentityTypes {
  identified,
  unknown,
  anonymous,
}
